import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../styled/common';
import { Typography } from '../Typography';

export const ToggleContainer = styled(FlexibleDiv)`
  position: relative;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  padding: 5px;
  border-radius: 30px;
  height: 50px;
  gap: 5px;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  cursor: default;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    max-width: 335px;
    flex: auto;
  }
`;

export const Highlight = styled.div<{ $index: number; $count: number }>`
  position: absolute;
  top: 5px;
  bottom: 5px;
  left: 5px;
  width: calc((100% - 10px) / ${({ $count }) => $count});
  border-radius: 30px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  transition: transform 0.3s ease;
  transform: translateX(${({ $index }) => $index * 100}%);
`;

export const OptionText = styled(Typography)<{ $isSelected: boolean }>`
  color: ${({ theme }) => theme.colors.text.primary};
  transition: color 0.3s ease;
  z-index: 1;
  position: relative;
  text-align: center;
`;

export const ToggleOption = styled.div<{ $isSelected: boolean }>`
  border-radius: 30px;
  position: relative;
  z-index: 1;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $allowReselect, $isSelected }) =>
    !$allowReselect && $isSelected ? 'default' : 'pointer'};

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex: 1;
  }

  ${({ $isSelected }) =>
    !$isSelected &&
    css`
      @media (hover: hover) {
        &:hover {
          ${OptionText} {
            color: ${({ theme }) => theme.colors.systemColors.blue};
          }
        }
      }
    `}
`;
